import { Routes, Route, Navigate } from "react-router-dom";
import Splash from "./screens/Splash";
import Modes from "./screens/Modes";
import Packs from "./screens/Packs";
import PackEntry from "./screens/PackEntry";
import Players from "./screens/Players";
import SessionScreen from "./screens/Session";
import Stats from "./screens/Stats";
import Settings from "./screens/Settings";
import AdminLayout from "./admin/AdminLayout";
import { LanguageProvider } from "./state/language";

export default function App() {
  return (
    <LanguageProvider>
      {/* Film-grain overlay — one fixed layer for the whole app. */}
      <div className="pp-grain" aria-hidden />
      <Routes>
        <Route path="/" element={<Splash />} />
        {/* UA-only mode: /language route disabled. Re-enable with LanguagePicker import. */}
        <Route path="/language" element={<Navigate to="/modes" replace />} />
        <Route path="/modes" element={<Modes />} />
        <Route path="/packs/:modeId" element={<Packs />} />
        <Route path="/pack/:packId" element={<PackEntry />} />
        <Route path="/players/:packId" element={<Players />} />
        <Route path="/session/:sessionId" element={<SessionScreen />} />
        <Route path="/stats/:sessionId" element={<Stats />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin/*" element={<AdminLayout />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </LanguageProvider>
  );
}
